export default "__VITE_ASSET__CSZ2rHIT__"